import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

/* Security form component */
class SecurityForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
      repassword: '',
      number: ''
    }
    this.onInvalid = this.onInvalid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  handleSubmit = (e) => {
    if (this.state.password === '' ||
      this.state.repassword === '' ||
      this.state.number === '' ||
      this.state.repassword.length < 3) {
      return true
    } else {
      e.preventDefault()
      if (this.state.password !== this.state.repassword) {
        $('#change-password-form-msg').text("Passwords Don't Match");
        console.error('Password dont match')
      } else if (this.state.number !== '13') {
        $('#change-password-form-msg').text('Oops! 5 + 8 is not ' + this.state.number)
        console.error('Oops! 5 + 8 is not ' + this.state.number)
      } else {
        $('#change-password-form-msg').text('Your password has been updated.')
        this.setState = ({
          password: '',
          repassword: '',
          number: ''
        })
      }
      return false
    }
  }

  onChange = (e) => {
    switch (e.target.id) {
      case 'password':
        this.setState({ password: e.target.value })
        break;
      case 'repeat':
        this.setState({ repassword: e.target.value })
        break;
      case 'number':
        this.setState({ number: e.target.value })
        break;
      default:
        break;
    }
  }

  onInvalid = (e) => {
    switch (e.target.id) {
      case 'password':
        $('#password')[0].setCustomValidity('3 characters minimum')
        break;
      case 'repeat':
        $('#repeat')[0].setCustomValidity('3 characters minimum')
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <form id="change-password-form">
        <div className="col-sm-12 col-lg-4 form">
          <div className="row">
            <div className="form-group">
            <label>New password</label>
            <input type="password" id="password" placeholder="New password" pattern=".{3,}" value={this.state.password} onChange={this.onChange} onInvalid={this.onInvalid} className="form-control" required />
          </div>    
          <div className="form-group">
            <label>Confirm new password</label>
            <input type="password" id="repeat" placeholder="Repeat new password" pattern=".{4,}" onInvalid={this.onInvalid} value={this.state.repassword} onChange={this.onChange} className="form-control" required />
          </div>  
          <div className="form-group">
            <label>Verify you are a human</label>
            <input type="number" id="number" placeholder="5 + 8 = ?" className="form-control" onChange={this.onChange} value={this.state.number} required />
          </div>
          <p id="change-password-form-msg" className="msg"></p>
          <button type="submit" className="btn btn-default" onClick={this.handleSubmit}>Update password</button> 
          </div>
        </div>
      </form>
    )
  }
}

const Input = (props) => (
  <div className="form-group">
    <label>{props.label}</label>
    <input 
      id={props.id}
      type={props.type}
      onChange={props.onChange}
      className="form-control" 
    />
    <span className="hint">{props.hint}</span>
  </div>
) 

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  hint: PropTypes.string
}

export default SecurityForm


// WEBPACK FOOTER //
// ./src/components/pages/Settings/SecurityForm.js